module.exports = __webpack_public_path__ + "static/media/dzangolab.b957a591.png";